// Generated by GitHub Copilot
import { createFileRoute } from '@tanstack/react-router'
import { WorkOrdersSettingsPage } from '#components/domain/operations/work-orders/settings/work-orders-settings-page.tsx'

export const Route = createFileRoute('/_appSettings/$companyId/settings/work-orders')({
  component: WorkOrdersSettingsPage,
})
